import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Whatsapp(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M4 12a8 8 0 113.96 6.906 1 1 0 00-.773-.101l-2.724.753.775-2.653a1 1 0 00-.103-.795A7.958 7.958 0 014 12zm8-10C6.477 2 2 6.477 2 12a9.96 9.96 0 001.199 4.751L2.04 20.72a1 1 0 001.226 1.244l4.059-1.122A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm2.004 12.226l.435-.38a.83.83 0 011-.07l1.068.699a.835.835 0 01.135.11l.114.114a.842.842 0 01-.069 1.248l-.9.725c-.296.238-.663.369-1.038.317-.977-.136-3.018-.634-4.839-2.466-1.77-1.781-2.555-3.983-2.862-5.117-.13-.475.01-.97.329-1.344l.654-.769a.83.83 0 011.263-.004l.616.714.655.778a.831.831 0 01-.172 1.224c-.29.194-.425.55-.3.877.35.922 1.257 2.745 3.141 3.495a.752.752 0 00.77-.152z",
    clipRule: "evenodd"
  }));
}

export default Whatsapp;